<template>
        <section class="social">
            <div data-aos="flip-up" data-aos-duration="1000" class="section-title d-none">
                <h2>شبکه های اجتماعی</h2>
                <p>مارا در شبکه های اجتماعی دنبال نمایید</p>
            </div>
            <div class="col-12">
                <div class="middle">
                    <a :href="siteSetting.faceBookLink" v-if="siteSetting.faceBookLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'facebook-f']" />
                    </a>
                    <a :href="siteSetting.telegramLink" v-if="siteSetting.telegramLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'telegram-plane']" />
                    </a>
                    <a :href="siteSetting.yahooLink" v-if="siteSetting.yahooLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'yahoo']" />
                    </a>
                    <a :href="siteSetting.twitterLink" v-if="siteSetting.twitterLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'twitter']" />
                    </a>
                    <a :href="siteSetting.gmailLink" v-if="siteSetting.gmailLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'google']" />
                    </a>
                    <a :href="siteSetting.instagramLink" v-if="siteSetting.instagramLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'instagram']" />
                    </a>
                    <a :href="siteSetting.youTubeLink" v-if="siteSetting.youTubeLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'youtube']" />
                    </a>
                    <a :href="siteSetting.linkeDinLink" v-if="siteSetting.linkeDinLink">
                        <font-awesome-icon size="3x" :icon="['fab', 'linkedin-in']" />
                    </a>
                </div>
            </div>
        </section>
</template>
<script>
    export default {

        props: {
            siteSetting: {
                type: Object
            }
        },

        data()
        {
            return {};
        }
    };
</script>
<style scoped>

    .social {
        background: #fff;
    }

        .social .middle {
            text-align: center;
        }

        .social a {
            display: inline-block;
            width: 90px;
            height: 90px;
            background: #fff;
            margin: 10px;
            border-radius: 30%;
            color: #292929;
            overflow: hidden;
            position: relative;
        }

            .social a svg {
                margin-top: 20px;
                transition: 0.2s linear;
            }

            .social a:hover svg {
                transform: scale(1.2);
                color: #fff;
                position: relative;
            }

            .social a::before {
                content: "";
                position: absolute;
                height: 120%;
                width: 120%;
                background: #d00918;
                transform: rotate(45deg);
                left: -110%;
                top: 90%;
            }

            .social a:hover::before {
                animation: social-animation 0.7s 1;
                top: -10%;
                left: -10%;
            }

    @keyframes social-animation {
        0% {
            top: -110%;
            left: 90%;
        }

        50% {
            top: 10%;
            left: -30%;
        }

        100% {
            top: -10%;
            left: -10%;
        }
    }
</style>
